import { COST_CENTER_MANAGMENT_CONTROL, NEW_COST_CENTER_MANAGMENT_CONTROL } from "./common";
export const BUSINESS_UNIT_RESIDENTIAL_CODE = "RE"
export const BUSINESS_UNIT_COMMERCIAL_CODE = "CI"
export const BUSINESS_UNIT_CODE_GENERATION_PROJECTS = 'PG'

export const ACTIVE_BUSINESS_UNITS = [
    'RESIDENCIAL',
    'COMERCIAL INDUSTRIAL',
    'PROYECTOS DE GENERACION'
]


export const TYPE_PROJECTS_RESIDENTIAL = [
    {
        id: 'B2C',
        name: 'B2C',
    },
    {
        id: 'B2B',
        name: 'B2B',
    }
]

export const TYPE_PROJECTS_COMMERCIAL = [
    {
        id: 'Venta Organica',
        name: 'Venta Orgánica',
    },
    {
        id: 'Grandes Clientes',
        name: 'Grandes Clientes',
    }
]

export const PERMISSION_FROM_BUSINESS_UNIT_TO_MODIFY_MAINTAINER_DOCUMENTS = {
    [BUSINESS_UNIT_RESIDENTIAL_CODE]: [
        'g.barros@fluxsolar.cl'
    ],
    [BUSINESS_UNIT_COMMERCIAL_CODE]: [
        'g.adasme@fluxsolar.cl',
        'v.cordova@fluxsolar.cl'
    ],
    [BUSINESS_UNIT_CODE_GENERATION_PROJECTS]: [
        'r.toro@fluxsolar.cl',
        'p.hartley@fluxsolar.cl'
    ]
}
export const PERMISSION_FOR_CECO = [
    {
        business_unit_code: 'CI',
        cecos: [
            'CI-COM',
            'CI-GER',
            'AF-CDG',
            '301',
            '300',
            '108'
        ]
    },
    {
        business_unit_code: 'RE',
        cecos: [
            'RE-COM',
            'RE-GER',
            'AF-CDG',
            '201',
            '200',
            '108'
        ]
    },
    {
        business_unit_code: 'PG',
        cecos: [
            'PG-COM',
            'PG-GER',
            'AF-CDG',
            '401',
            '400',
            '108'
        ]
    }
]

// #Form Client And Project Variables
export const STATUS_PRESALE_REVIEW_PENDING = 'Pendiente de Revisión';
export const STATUS_PRESALE_APPROVED = 'Aprobado';
export const STATUS_PRESALE_REVIEW_USER = 'Revisión por Usuario';
export const STATUS_PRESALE_PENDING_SIGNED = 'Pendiente de firma'
export const STATUS_PRESALE_SIGNED = 'Contrato Firmado'
export const LIST_STATUS_PRESALE = [
    {
        id: STATUS_PRESALE_REVIEW_PENDING,
        name: STATUS_PRESALE_REVIEW_PENDING,
    },
    {
        id: STATUS_PRESALE_REVIEW_USER,
        name: STATUS_PRESALE_REVIEW_USER,
    },
    {
        id: STATUS_PRESALE_PENDING_SIGNED,
        name: STATUS_PRESALE_PENDING_SIGNED,
    },
    {
        id: STATUS_PRESALE_SIGNED,
        name: STATUS_PRESALE_SIGNED,
    },
]

export const TYPE_CLIENT_COMPANY = 'company'
export const TYPE_CLIENT_PERSON = 'natural-person'
export const BUSINESS_CATEGORY_PARTICULAR = 'PARTICULAR'

// #Sign Contract Variables
export const NAME_FOLDER_SALE_RESIDENTIAL = '1.2 Venta'
export const NAME_FILE_CONTRACT = 'Contrato'
export const NAME_FILE_IDENTITY_CARD = 'Cédula de Identidad [Cliente]'